import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_down",
  "use": "icon-arrow_down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-arrow_down\">\n<g>\n\t<g>\n\t\t<path d=\"M9.8,15.7L9.8,15.7c-0.3,0-0.6-0.1-0.8-0.3l-8.2-9C0.4,6,0.4,5.3,0.8,4.9S2,4.5,2.4,5l7.5,8.1l7.8-8.5\n\t\t\tc0.4-0.4,1.1-0.5,1.5-0.1c0.4,0.4,0.5,1.1,0.1,1.5l-8.6,9.3C10.4,15.6,10.1,15.7,9.8,15.7z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol